import React from 'react';
import { useOfflineStatusContext } from '../context/offlineStatusContext';

const ManualModeBanner = () => {
  const { autoSyncEnabled } = useOfflineStatusContext();

  if (autoSyncEnabled) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        backgroundColor: '#faad14',
        zIndex: 9999,
        boxShadow: '0 2px 4px rgba(250, 173, 20, 0.3)',
      }}
      title="Ručni režim - Automatska sinhronizacija isključena"
    />
  );
};

export default ManualModeBanner;
